import React from 'react';

import { Alert, Stack, Typography, Section } from '@gogame/components';

export const CostModelsWarning = () => (
  <Stack>
    <Typography variant={'caption'} gutterBottom>
      A cost model creating/change requires approval from your manager or the VP
      if the following is true:
    </Typography>
    <Typography variant={'caption'}>
      - The cost model is changed for a period in the last month or older (not
      the current month)
    </Typography>
    <Typography variant={'caption'}>
      - The difference between the current and new spend is more than $1,000 or
      less than -$10,0000
    </Typography>
  </Stack>
);

export const CostModelsSection = ({ costModels, platformName }) => {
  return (
    <Section
      prompt={<CostModelsWarning />}
      title={`${platformName ? `${platformName} ` : ''}Cost Models`}
    >
      <Stack spacing={2}>
        <Alert severity={'info'}>
          Make sure you have selected correct cost models. You will{' '}
          <strong>not be able to change</strong> them.
        </Alert>

        <div>{costModels}</div>
      </Stack>
    </Section>
  );
};
